module.exports = __webpack_public_path__ + "img/vip.db0d6e7e.png";